import { ApolloLink } from '@apollo/client';

const RelevantHeaderRegExp = /^(x-hasura-.+|authorization|cookie)/i;
function extractRequestRelevantHeaders(headers: Request['headers']) {
    return (
        Object.fromEntries(
            [...(headers?.entries?.() || [])].filter(([name]) =>
                name.match(RelevantHeaderRegExp)
            )
        ) || {}
    );
}

const headersLink = (request?: Request) =>
    new ApolloLink((operation, forward) => {
        const context = operation.getContext();
        operation.setContext({
            ...context,
            headers: extractRequestRelevantHeaders(
                new Headers({
                    ...(request?.headers && {
                        ...Object.fromEntries(request?.headers),
                    }),
                    ...context.headers,
                })
            ),
        });
        return forward(operation);
    });

export default headersLink;
